import { post, get, put, del as requestDel } from '@/utils/request';

// 新增/修改工序
export function ProcedureAdd(Data) {
  if (Data.id && Data.id > 0) {
    return put('/api/v1/procedure/' + Data.id, Data);
  }
  return post('/api/v1/procedure', Data); 
}

// 工序分页列表
export function ProcedureList(Data) {
  return get('/api/v1/procedure/page', Data); 
}

// 删除工序
export function ProcedureDel(Data) {
  const id = typeof Data === 'object' ? Data.id : Data;
  return requestDel('/api/v1/procedure/' + id); 
}

// 工序详情
export function ProcedureDetail(Data) {
  const id = typeof Data === 'object' ? Data.id : Data;
  return get('/api/v1/procedure/detail', { id }); 
}

// 工序下拉列表
export function ProcedureDropdownList() {
  return get('/api/v1/procedure/list');
}
